"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StarShieldSymbolIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "24",
  viewBox: "0 0 20 24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M3.302 3.228C1.986 3.642.996 4.984 1 6.347v.414a.89.89 0 101.782 0v-.416c-.002-.588.482-1.237 1.068-1.422a22.585 22.585 0 0114.234.004c.553.174 1.056.851 1.056 1.42v8.785c-.005.769-.471 2.112-1.084 2.751C14.825 21.201 12.738 23 10.96 23c-1.775 0-3.862-1.797-7.087-5.107-.62-.65-1.087-1.991-1.091-2.753v-3.021a.89.89 0 10-1.782 0v3.026c.005 1.146.6 2.947 1.59 3.985 3.652 3.749 5.949 5.652 8.37 5.652 2.423 0 4.721-1.904 8.377-5.66.985-1.026 1.579-2.83 1.585-3.985v-8.79c0-1.34-1.01-2.71-2.288-3.115a24.51 24.51 0 00-15.332-.003z",
      transform: "translate(-1 -1) translate(0 -1) translate(0 .567)",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M1 10a1 1 0 112 0 1 1 0 01-2 0",
      transform: "translate(-1 -1) translate(0 -1)",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M8.361 12.261l.991.966a.75.75 0 01.216.664l-.233 1.365 1.225-.644a.747.747 0 01.697 0l1.226.644-.234-1.365a.75.75 0 01.216-.664l.991-.966-1.37-.199a.752.752 0 01-.565-.41l-.612-1.242-.612 1.242a.754.754 0 01-.565.41l-1.37.199zm5.118 5.116a.753.753 0 01-.348-.086l-2.222-1.168-2.222 1.168A.752.752 0 017.6 16.5l.424-2.474-1.797-1.751a.75.75 0 01.415-1.28l2.485-.361 1.11-2.25c.254-.512 1.092-.512 1.346 0l1.11 2.25 2.484.361a.748.748 0 01.605.511.748.748 0 01-.19.769l-1.797 1.751.424 2.474a.751.751 0 01-.739.877z",
      transform: "translate(-1 -1) translate(0 -1)",
      className: "svg-fill-primary"
    })]
  })]
});

StarShieldSymbolIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(StarShieldSymbolIcon);

exports.default = _default;